import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, ShieldCheck, Lock, CreditCard } from 'lucide-react';
import { Button } from './ui/Button';
export function Hero() {
  return <section className="relative pt-10 pb-8 md:pt-32 md:pb-32 overflow-hidden bg-dark-900" data-id="element-217">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-lime-500/10 rounded-full blur-[120px] pointer-events-none" data-id="element-218" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-219">
        <div className="flex flex-col items-center text-center lg:text-left lg:grid lg:grid-cols-2 lg:gap-8 lg:items-center" data-id="element-220">
          <motion.div initial={{
          opacity: 0,
          x: -50
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8
        }} className="flex flex-col gap-6 items-center lg:items-start" data-id="element-221">
            <div className="flex flex-col items-center lg:items-start" data-id="element-222">
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-dark-800 border border-dark-700 text-lime-400 text-xs md:text-sm font-bold tracking-wider mb-3 md:mb-4" data-id="element-223">
                <span className="relative flex h-2 w-2" data-id="element-224">
                  <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-lime-400 opacity-75" data-id="element-225"></span>
                  <span className="relative inline-flex rounded-full h-2 w-2 bg-lime-500" data-id="element-226"></span>
                </span>
                SISTEMA COMPLETO
              </div>
              <h1 className="md:text-6xl lg:text-7xl font-display font-bold tracking-tight mb-4 text-[28px]" data-id="element-227">
                FUNCIONAL &{' '}
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-lime-400 to-lime-600 text-[28px]" data-id="element-228">
                  CROSS 360
                </span>
                <br data-id="element-229" />
                MEGAPACK
              </h1>
            </div>

            {/* Mockup image — visible on mobile between title and subtitle, hidden on lg */}
            <motion.div initial={{
            opacity: 0,
            y: 30
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.8,
            delay: 0.15
          }} className="relative w-full max-w-[256px] md:max-w-xs mx-auto my-1 md:my-2 lg:hidden" data-id="element-230">
              <div className="absolute inset-0 bg-gradient-to-tr from-lime-500/20 to-transparent rounded-3xl blur-2xl transform rotate-6" data-id="element-231"></div>
              <img src="https://cdn.magicpatterns.com/uploads/wDSzmWNitusVLWrXkgbcnK/heylloyd-image-1776040223106-Photoroom.png" alt="Funcional & Cross 360 MegaPack Mockup" className="relative z-10 w-full h-auto drop-shadow-2xl" data-id="element-232" />
            </motion.div>

            <p className="text-lg md:text-2xl text-gray-400 font-medium leading-relaxed max-w-xl" data-id="element-233">
              Todo tu año de entrenamiento funcional resuelto. 6 Tomos · 50+
              WODs · 6 Bonos · Listo para usar.
            </p>

            <div className="space-y-3" data-id="element-234">
              <p className="text-gray-300 text-sm md:text-base" data-id="element-235">
                Tu año completo de clases listo: WODs, HIIT, ABS, programación,
                objetivos y crecimiento.{' '}
                <strong className="text-white" data-id="element-236">Sin improvisar.</strong>
              </p>

              <ul className="grid grid-cols-2 gap-2 mt-3" data-id="element-237">
                {['PDF digital', 'Acceso inmediato', 'Todos los niveles', 'Listo para imprimir'].map((item, i) => <li key={i} className="flex items-center gap-2 text-gray-300 text-sm md:text-base justify-center lg:justify-start" data-id="element-238">
                    <CheckCircle2 className="w-4 h-4 md:w-5 md:h-5 text-lime-500 flex-shrink-0" data-id="element-239" />
                    <span data-id="element-240">{item}</span>
                  </li>)}
              </ul>
            </div>

            <div className="pt-2 w-full flex flex-col items-center lg:items-start" data-id="element-241">
              <Button href="#pricing" size="xl" fullWidth className="md:w-auto" data-id="element-242">
                💥 QUIERO MI FUNCIONAL & CROSS 360 AHORA
              </Button>

              <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6 mt-4 text-xs md:text-sm text-gray-400" data-id="element-243">
                <div className="flex items-center gap-1.5" data-id="element-244">
                  <ShieldCheck className="w-4 h-4 text-lime-500" data-id="element-245" />
                  <span data-id="element-246">Garantía 7 días</span>
                </div>
                <div className="flex items-center gap-1.5" data-id="element-247">
                  <Lock className="w-4 h-4 text-lime-500" data-id="element-248" />
                  <span data-id="element-249">Pago 100% seguro</span>
                </div>
                <div className="flex items-center gap-1.5" data-id="element-250">
                  <CreditCard className="w-4 h-4 text-lime-500" data-id="element-251" />
                  <span data-id="element-252">Mercado Pago | Tarjeta</span>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Mockup image — visible on desktop only */}
          <motion.div initial={{
          opacity: 0,
          y: 50
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="relative lg:ml-auto hidden lg:block" data-id="element-253">
            <div className="relative w-full max-w-lg mx-auto" data-id="element-254">
              <div className="absolute inset-0 bg-gradient-to-tr from-lime-500/20 to-transparent rounded-3xl blur-2xl transform rotate-6" data-id="element-255"></div>
              <img src="https://cdn.magicpatterns.com/uploads/wDSzmWNitusVLWrXkgbcnK/heylloyd-image-1776040223106-Photoroom.png" alt="Funcional & Cross 360 MegaPack Mockup" className="relative z-10 w-full h-auto drop-shadow-2xl hover:scale-[1.02] transition-transform duration-500" data-id="element-256" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}